import {Resource, ResourceCollection} from 'simpli-web-sdk'
import {NoneResource} from '@/model/NoneResource'
import {TipoMarcaVeiculo} from '@/enums/TipoMarcaVeiculo'

export class TipoMarcaVeiculoCollection {
  options() {
    return new ResourceCollection(
      NoneResource,
      Object.values(TipoMarcaVeiculo).map(
        (tipo: string) =>
          ({
            $id: tipo,
            $tag: tipo,
          } as Resource)
      )
    )
  }
}
